import React from "react";
import { Modal } from "@/components/_shared/Modal";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface RaumEinstellungenProps {
	isOpen: boolean;
	onClose: () => void;
	passwort: string;
	onPasswortChange: (value: string) => void;
	nurBesitzerEdit: boolean;
	onNurBesitzerEditChange: (value: boolean) => void;
	onSpeichern: () => void;
}

export function RaumEinstellungen({
	isOpen,
	onClose,
	passwort,
	onPasswortChange,
	nurBesitzerEdit,
	onNurBesitzerEditChange,
	onSpeichern,
}: RaumEinstellungenProps) {
	return (
		<Modal isOpen={isOpen} onClose={onClose} title="TextShare-Einstellungen">
			<div className="space-y-6 p-2">
				<div className="space-y-3">
					<Label htmlFor="password-setting">Passwort (optional)</Label>
					<Input
						id="password-setting"
						onChange={(e) => onPasswortChange(e.target.value)}
						placeholder="Leer lassen für keinen Passwortschutz"
						type="password"
						value={passwort}
					/>
					<p className="text-gray-500 text-xs dark:text-gray-400">
						Hinweis: Wenn du ein Passwort setzt, müssen alle Benutzer dieses
						Passwort eingeben, um auf den Raum zuzugreifen.
					</p>
				</div>

				<div className="space-y-3">
					<div className="flex items-center space-x-2">
						<Switch
							checked={nurBesitzerEdit}
							id="edit-permission-switch"
							onCheckedChange={onNurBesitzerEditChange}
						/>
						<Label htmlFor="edit-permission-switch">
							Nur ich darf den Text bearbeiten
						</Label>
					</div>
					<p className="text-gray-500 text-xs dark:text-gray-400">
						Wenn deaktiviert, können alle Benutzer den Inhalt des Textshares
						bearbeiten.
					</p>
				</div>

				<div className="mt-6 flex justify-end space-x-2">
					<Button onClick={onClose} type="button" variant="outline">
						Abbrechen
					</Button>
					<Button onClick={onSpeichern} type="button">
						Speichern
					</Button>
				</div>
			</div>
		</Modal>
	);
}
